<template>
  <div class="grayHeader">
     {{title}}
  </div>
</template>

<script>
export default {
  props:{
    title:{
      type:String
    }
  }
}
</script>

<style lang="scss">
  .grayHeader{
    background-color: #D9D9D9;
    height:37px;
    width:199px ;
    color: #1B1B1B;
    font-size: 16px;
    padding: 6px 15px;
    margin-bottom: 11px;
  } 
</style>